// PropallyApiFactory（src/module/CustomApiFactory.tsx）の axios interceptor を通ったエラーかを判定する。
//
// MEMO:
// 同 factory 経由の API 呼び出しの失敗は、すべて interceptor が
// 「Sentry へ送る」か「意図的に送らない（shouldSkipSentryReport）」のどちらかで処理し終えている。
// そのうえ呼び出し側の catch で console.error / console.warn すると、
// CaptureConsole（src/index.tsx は error / warn を拾う）が同じ失敗をもう一度イベント化するため、
//   - interceptor が送った失敗は、1 つの原因が 2 つの Sentry イシューに分裂する
//     （例: GET /v1/min_app_version の 504 が PROPALLY_WEB-269 と PROPALLY_WEB-280 に分かれた）
//   - interceptor が意図的に外した失敗は、呼び出し側のログ経由で Sentry に復活する
// の 2 つが起きる。報告経路を interceptor 1 本に寄せればどちらも防げる。
//
// 逆に interceptor を通らないエラー（Capacitor プラグインの失敗、呼び出し側の実装バグなど）は
// 呼び出し側のログが唯一の報告経路なので、従来どおり error / warn のまま残す必要がある。
//
// 判定には axios が生成するエラーが必ず持つ `isAxiosError: true` を使う。
// このアプリで `axios` を import しているのは CustomApiFactory.tsx だけ（interceptor 付きの
// インスタンスを 1 つだけ作って PropallyApiFactory から配っている）ため、
// axios 由来のエラーであれば interceptor を通っていると言える。
// 素の axios や別インスタンスを直接使う箇所を足す場合は、この前提が崩れるので併せて見直すこと。
export const isHandledByApiInterceptor = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  return (error as { isAxiosError?: boolean }).isAxiosError === true;
};
